import React               from 'react'
import DashboardDropdown   from './dashboard_dropdown'
import EditDashboard       from './edit_dashboard'
import EditTable           from './edit_table'
import TableDropdown       from './table_dropdown'
import { postRequest,
         patchRequest,
         deleteRequest,
         pathname }       from "@helpers/javascript/javascript"

const DashboardControls = ({
  exportId,
  exportTitle,
  setDashboardView,
  dashboards,
  widgetTemplates,
  exportModel,
  setDashboards,
  currentDashboard,
  setCurrentDashboard,
  originalDashboard,
  setOriginalDashboard,
  hideDashboardButton,
  userCanRead,
  userCanSave,
  dashboardView,
  isDashboardDirty,
  columns = [],
  tables = [],
  setTables,
  currentTable,
  setCurrentTable,
  originalTable,
  setOriginalTable,
  isTableDirty,
  userIsAdmin,
}) => {
  const openDashboard = dashboard => {
    setCurrentDashboard(dashboard)
    setOriginalDashboard(dashboard)
    setDashboardView(true)

    const currentUrl = new URL(window.location.origin)
    currentUrl.pathname = `/export_dashboards/${dashboard.id}`
    currentUrl.searchParams.set("export", exportId)
    window.history.pushState({}, '', currentUrl.toString())
  }

  const saveDashboard = (name, widgets=[]) => {
    const selectedWidgets = widgets.length > 0 ? widgets : currentDashboard.widgets
    const path = "/export_dashboards"
    const body = {
      export: exportId,
      dashboard: {
        title:       name.trim(),
        widgets:     selectedWidgets,
        export_type: exportModel
      },
    }
    const url = pathname({ path, format: "json" })
    
    postRequest({ url, body }).then(res => {
      if (res.error) {
        flashAlert(res.error || I18n.t('export.dashboard_not_saved'))
      } else {  
        setDashboards(res.dashboards)
        setCurrentDashboard(res.dashboard)
        setCurrentDashboard(prev => ({
          ...prev,
          widgets
        }))
        
        if (widgets.length > 0) {
          flashNotice(I18n.t('export.dashboard_saved'))
        } else {
          flashNotice(I18n.t('export.dashboard_duplicated'))
        }
        
        const currentUrl = new URL(window.location.origin)
        currentUrl.pathname = `/export_dashboards/${res.dashboard.id}`
        currentUrl.searchParams.set("export", exportId)
        window.history.pushState({}, '', currentUrl.toString())
      }
    })
  }

  const updateDashboard = (published=null) => {
    if (!!published && !confirm(I18n.t("export.publish_sure"))) return

    const path = `/export_dashboards/${currentDashboard.id}`
    const body = {
      export: exportId,
      dashboard: {
        title:       currentDashboard.name,
        widgets:     currentDashboard.widgets,
        export_type: exportModel,
        ...(published !== null ? { published } : {})
      },
    }
    const url = pathname({ path, format: "json" })
    
    patchRequest({ url, body }).then((res) => {
      if (res.error) {
        flashAlert(res.error || I18n.t('export.dashboard_not_saved'))
      } else {
        if (published === true) {
          flashNotice(I18n.t('export.dashboard_published'))
        } else if (published === false) {
          flashNotice(I18n.t('export.dashboard_unpublished'))
        } else {
          flashNotice(I18n.t('export.dashboard_saved'))
        }
        setDashboards(res.dashboards)
        setCurrentDashboard(res.dashboard)
      }
    })
  }

  const openTable = table => {
    setCurrentTable(table)
    setOriginalTable(table)

    const currentUrl = new URL(window.location.origin)
    currentUrl.pathname = `/export_tables/${table.id}`
    currentUrl.searchParams.set("export", exportId)
    window.history.pushState({}, '', currentUrl.toString())
  }

  const deleteTable = () => {
    if (!confirm(I18n.t("export.delete_table_sure"))) return

    const url = pathname({ path: `/export_tables/${currentTable.id}`, format: "json" }) + `?export=${exportId}`
    deleteRequest(url).then(res => {
      if (res.error) {
        flashAlert(res.error || I18n.t('export.table_not_deleted'))
      } else {
        setTables(res.tables)
        setCurrentTable(null)
        setOriginalTable(null)
        showAllColumns()
        flashNotice(I18n.t('export.table_deleted'))
      }
    })
  }

  const showAllColumns = () => {
    setCurrentTable(null)
    setOriginalTable(null)

    const currentUrl = new URL(window.location.origin)
    currentUrl.pathname = `/exports/${exportId}`
    window.history.pushState({}, '', currentUrl.toString())
  }

  const saveTable = (selectedColumns, name) => {
    const path = "/export_tables"
    const body = {
      export: exportId,
      table: {
        title:       name.trim(),
        columns:     selectedColumns,
        export_type: exportModel
      },
    }
    const url = pathname({ path, format: "json" })

    postRequest({ url, body }).then(res => {
      if (res.error) {
        flashAlert(res.error || I18n.t('export.table_not_saved'))
      } else {
        setTables(res.tables)
        setCurrentTable(res.table)
        setOriginalTable(res.table)
        flashNotice(I18n.t('export.table_saved'))
      }
    })
  }

  const updateTable = (published=null) => {
    if (!!published && !confirm(I18n.t("export.publish_sure"))) return

    const path = `/export_tables/${currentTable.id}`
    const body = {
      export: exportId,
      table: {
        title:       currentTable.name,
        columns:     currentTable.columns,
        export_type: exportModel,
        ...(published !== null ? { published } : {})
      },
    }
    const url = pathname({ path, format: "json" })

    patchRequest({ url, body }).then(res => {
      if (res.error) {
        flashAlert(res.error || I18n.t('export.table_not_saved'))
      } else {
        if (published === true) {
          flashNotice(I18n.t('export.table_published'))
        } else if (published === false) {
          flashNotice(I18n.t('export.table_unpublished'))
        } else {
          flashNotice(I18n.t('export.table_saved'))
        }
        setTables(res.tables)
        setCurrentTable(res.table)
        setOriginalTable(res.table)
      }
    })
  }

  const showTable = () => {
    setDashboardView(false)
    setCurrentDashboard(null)

    const currentUrl = new URL(window.location.origin)
    currentUrl.pathname = `/exports/${exportId}`
    window.history.pushState({}, '', currentUrl.toString())
  }

  const duplicateName = currentDashboard?.name + I18n.t("export.copy")

  return (
    <div className = "d-flex j-c-between a-i-start mb-2">
      <div
        id        = "left-buttons"
        className = {`d-flex a-i-start text-nowrap flex-shrink-0 ${dashboardView && 'd-none'}`}
      >
          <button
              className   = "btn btn-primary small btn-sm mr-2"
              data-toggle = "modal"
              data-target = "#csv-email"
            >
            <i className = "fa fa-envelope" /> {I18n.t("export.email")}
          </button>

          <TableDropdown
            columns        = {columns}
            tables         = {tables}
            openTable      = {openTable}
            showAllColumns = {showAllColumns}
            saveTable      = {saveTable}
            userCanSave    = {userCanSave}
          />
      </div>

      <div className = "d-flex a-i-start text-nowrap flex-shrink-0 no-print">
        { dashboardView &&
          <button
            className = "btn btn-primary small btn-sm mr-2"
            onClick   = {showTable}
          >
            <i className = "fa fa-table" /> {I18n.t("export.table")}
          </button>
        }
      </div>
      {
        userCanRead && !hideDashboardButton &&
          <div className = "no-print text-nowrap flex-shrink-0">
            <DashboardDropdown
              widgetTemplates      = {widgetTemplates}
              dashboards           = {dashboards}
              openDashboard        = {openDashboard}
              saveDashboard        = {saveDashboard}
              userCanSave          = {userCanSave}
              currentDashboard     = {currentDashboard}
              setOriginalDashboard = {setOriginalDashboard}
              setDashboardView     = {setDashboardView}
            />
          </div>
      }

      <div className = "mb-0 text-center flex-grow-1 d-flex j-c-around" style = {{ minWidth: 0 }}>
        { currentDashboard && currentDashboard.widgets.length
          ? <>
              <h5>{currentDashboard?.name}</h5>
              <div>{exportTitle}</div>
            </>   
          : <h5>{exportTitle}</h5>
        }
        <div 
          id        = "datatable-filter" 
          className = {dashboardView ? 'd-none' : "d-flex a-i-start"}
        ></div>
      </div>


      <div className = "d-flex a-i-start text-nowrap flex-shrink-0 no-print">
        { !dashboardView && userCanSave && currentTable && isTableDirty &&
          <>
            <button
              className = "btn btn-primary small btn-sm mr-2"
              onClick   = {() => setCurrentTable(originalTable)}
            >
              <i className = "fa fa-undo" /> {I18n.t("button.undo")}
            </button>

            <button
              className = "btn btn-primary small btn-sm mr-2"
              onClick   = {() => updateTable()}
            >
              <i className = "fa fa-save" /> {I18n.t("export.save")}
            </button>
          </>
        }

        { !dashboardView && userCanSave && currentTable && !isTableDirty &&
          <>
            <EditTable
              columns         = {columns}
              currentTable    = {currentTable}
              setCurrentTable = {setCurrentTable}
            />
            <div className = "dropdown no-print">
              <button
                className     = "btn btn-primary small btn-sm dropdown-toggle"
                type          = "button"
                data-toggle   = "dropdown"
                aria-haspopup = "true"
                aria-expanded = "false"
              >
                {I18n.t("export.actions")}
              </button>
              <div className = "dropdown-menu dropdown-menu-right" style = {{ minWidth: 'fit-content' }}>
                { !currentTable?.published &&
                  <button
                    className = "dropdown-item"
                    onClick   = {() => updateTable(true)}
                  >
                    <i className = "fa fa-share-alt mr-2" /> {I18n.t("export.publish")}
                  </button>
                }
                { currentTable?.published &&
                  <button
                    className = "dropdown-item"
                    onClick   = {() => updateTable(false)}
                  >
                    <i className = "fa fa-share-alt mr-2" /> {I18n.t("export.unpublish")}
                  </button>
                }
                { userCanSave &&
                  <button
                    className = "dropdown-item text-danger"
                    onClick   = {deleteTable}
                  >
                    <i className = "fa fa-trash mr-2" /> {I18n.t("export.delete_table")}
                  </button>
                }
              </div>
            </div>
          </>
        }

        { userCanSave && currentDashboard && isDashboardDirty &&
          <>
            <button
              className = "btn btn-primary small btn-sm mr-2 no-print"
              onClick   = {() => setCurrentDashboard(originalDashboard)}
              disabled  = {currentDashboard.widgets.length === 0}
            >
              <i className = "fa fa-undo" /> {I18n.t("button.undo")}
            </button>

            <button
              className = "btn btn-primary small btn-sm mr-2 no-print"
              onClick   = {() => updateDashboard()}
              disabled  = {currentDashboard.widgets.length === 0}
            >
              <i className = "fa fa-save" /> {I18n.t("export.save")}
            </button>
          </>
        }

        { userIsAdmin && currentDashboard &&
          <button
            className = "btn btn-primary small btn-sm mr-2 no-print"
            onClick   = {() => {
              // Force the dashboard to A4 width on-screen so Nivo's responsive
              // charts redraw at the printed size before window.print() snapshots
              // the page. Widgets keep their original 1/2/3 column widths — the
              // CSS in export_dashboard.scss handles the layout.
              document.body.classList.add('printing-dashboard')

              const cleanup = () => {
                document.body.classList.remove('printing-dashboard')
                window.dispatchEvent(new Event('resize'))
                window.removeEventListener('afterprint', cleanup)
              }
              window.addEventListener('afterprint', cleanup)

              // Two resize ticks let ResizeObserver-based charts settle; the
              // final delay covers Nivo's "gentle" enter animation.
              requestAnimationFrame(() => {
                window.dispatchEvent(new Event('resize'))
                requestAnimationFrame(() => {
                  window.dispatchEvent(new Event('resize'))
                  setTimeout(() => window.print(), 600)
                })
              })
            }}
          >
            <i className = "fa fa-print" /> {I18n.t("button.print")}
          </button>
        }

        { userCanSave && currentDashboard && !isDashboardDirty &&
          <>
            <EditDashboard
              exportId            = {exportId}
              widgetTemplates     = {widgetTemplates}
              userCanSave         = {userCanSave}
              currentDashboard    = {currentDashboard}
              setCurrentDashboard = {setCurrentDashboard}
              setDashboards       = {setDashboards}
              setDashboardView    = {setDashboardView}
            />
            <div className = "dropdown no-print">
              <button
                className     = "btn btn-primary small btn-sm dropdown-toggle"
                type          = "button"
                data-toggle   = "dropdown"
                aria-haspopup = "true"
                aria-expanded = "false"
              >
                {I18n.t("export.actions")}
              </button>
              <div className = "dropdown-menu dropdown-menu-right" style = {{ minWidth: 'fit-content' }}>
                <button
                  className = "dropdown-item"
                  onClick   = {() => saveDashboard(duplicateName)}
                  disabled  = {currentDashboard.widgets.length === 0}
                >
                  <i className = "fa fa-copy mr-2" /> {I18n.t("export.duplicate_dashboard")}
                </button>
                { !currentDashboard?.published &&
                  <button
                    className = "dropdown-item"
                    onClick   = {() => updateDashboard(true)}
                  >
                    <i className = "fa fa-share-alt mr-2" /> {I18n.t("export.publish")}
                  </button>
                }
                { currentDashboard?.published &&
                  <button
                    className = "dropdown-item"
                    onClick   = {() => updateDashboard(false)}
                  >
                    <i className = "fa fa-share-alt mr-2" /> {I18n.t("export.unpublish")}
                  </button>
                }
              </div>
            </div>
          </>
        }
      </div>
    </div>
  )
}

export default DashboardControls
